import axios from "axios";
import { Message } from "element-ui";
import Router from '@/router/index'

// 根据域名 和 NODE_ENV判定用那个base
// 具体配置信息 在.env.production 和 .env.development中
const origin = location.hostname//当前访问域名
let requestBase = ''
if (process.env.NODE_ENV === 'development') {

   requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY
//requestBase = 'https://gec-api-testserver.gecacademy.cn/crmServer/'
} else {
  if (origin.indexOf('-testserver') > -1) {
    requestBase = process.env.VUE_APP_DEV_API
  } else {
    requestBase = process.env.VUE_APP_MASTER_API
  }
}
// console.log('-=-=requestBase-=-=-', requestBase, process.env)
// requestBase = 'https://gec-api-testserver.gecacademy.cn/crmServer/'
// requestBase = 'https://gec-api.gecacademy.cn/crmServer/'
const config = {
  baseURL: requestBase,
  timeout: 60 * 1000 * 2, // Timeout
  withCredentials: true // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  cfg => {
    // console.dir("=====request====", cfg.headers)
    return cfg;
  },
  err => {
    return Promise.reject(err);
  }
);

_axios.interceptors.response.use(
  res => {
    const { error } = res.data;

    if (error.returnCode !== 0) {
      /**
       * 判断报错状态码的含义和处理
       * 10000 未登录，需要去center系统登录
       * 10001 center系统已登陆，但需要crm系统进行短信验证码验证登录
       * 111 没有对应的审批流，页面上会有对应弹窗写在对应模块上
       * **/
      if(error.returnCode === 10001) {

        if (window.location.pathname !== '/login' && window.location.pathname !== '/customerInfo') {
          Router.push('/login')
        }
        return Promise.reject(new Error('您还未登录'))
      }
      if (error.returnCode === 10000) {
        window.sessionStorage.clear()
        if (process.env.NODE_ENV === 'development') {
          window.location.href = "http://192.168.1.84:8080/login?form=" + window.location.origin
        } else {
          if (origin.indexOf('-testserver') > -1) {
            window.location.href = "https://center-testserver.gecacademy.cn/login?form=" + window.location.origin
          } else {
            window.location.href = "https://center.gecacademy.cn/login?form=" + window.location.origin
          }
        }
      }
      if (error.returnCode === 111) {
        Message.error(error.returnMessage)
        return Promise.reject(new Error('审批流报错'));
      } else if(error.returnMessage !== '请重新登录' ) {
        Message.error(error.returnMessage)
        return Promise.reject(new Error(error.returnMessage || "Error"));
      }
    } else {
      return res.data.data;
    }
  },
  err => {
    if (err.message == 'timeout of 30000ms exceeded') {
      Message({
        message: '请求超时请重试',
        type: "error",
        duration: 5 * 1000
      });
    } else {
      Message({
        message: err.message,
        type: "error",
        duration: 5 * 1000
      });
    }
    return Promise.reject(err);
  }
);

export default _axios;
